/**
 * How a scope type's name reads inside a sentence: "an account run works on its own account", "accounts". A type's
 * name is a person's word (Account, Deal, Scope test), so it is lower-cased and pluralised by the English rule.
 */
export function typeWords(name: string): { one: string; many: string; a: string } {
  const one = name.trim().toLowerCase();
  return { one, many: pluralWord(one), a: `${/^[aeiou]/.test(one) ? "an" : "a"} ${one}` };
}

/** The English plural of a word or of a phrase's last word: accounts, companies, boxes, scope tests. */
export function pluralWord(word: string): string {
  if (/[^aeiou]y$/i.test(word)) return `${word.slice(0, -1)}${word.endsWith("Y") ? "IES" : "ies"}`;
  if (/(s|x|z|ch|sh)$/i.test(word)) return `${word}es`;
  return `${word}s`;
}
